/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Signup_AgainInputs */

const en_newsletter_signup_again = /** @type {(inputs: Newsletter_Signup_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add another`)
};

/**
* | output |
* | --- |
* | "Add another" |
*
* @param {Newsletter_Signup_AgainInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_signup_again = /** @type {((inputs?: Newsletter_Signup_AgainInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Signup_AgainInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_signup_again(inputs)
});